import React, { useState, useEffect } from "react";
import "./progress-bar.scss";
const ProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const [progressTwo, setProgressTwo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prevProgress + 1;
      });
    }, 90);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setProgressTwo((prevProgress) => {
        if (prevProgress >= 95) {
          clearInterval(intervalTwo);
          return 95;
        }
        return prevProgress + 1;
      });
    }, 95);

    return () => clearInterval(intervalTwo);
  }, []);

  return (
    <>
      {" "}
      <div className="col-md-12 flexy mt">
        <div className="col-md-6">
          <h5 className="mt3">International Representation</h5>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}>
              {progress}%
            </div>
          </div>
          <h5 className="mt3">Academic Excellence</h5>
          <div className="progress-bar ">
            <div className="progress" style={{ width: `${progressTwo}%` }}>
              {progressTwo}%
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h5 className="mt3">Moral Discipline</h5>
          <div className="progress-bar ">
            <div className="progress" style={{ width: `${progressTwo}%` }}>
              {progressTwo}%
            </div>
          </div>
          <h5 className="mt3">Leadership Inculcation</h5>
          <div className="progress-bar ">
            <div className="progress" style={{ width: `${progress}%` }}>
              <center>
                <small> {progress}%</small>
              </center>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
